const LOCAL_SETTINGS_KEY = 'settings.riverside';

export const saveLocalSettings = (settings) => {
	try {
		const prev = getLocalSettings();
		const result = {};

		if ('mirrorVideo' in settings) {
			result.mirrorVideo = settings.mirrorVideo;
		}

		if (Object.keys(result).length > 0) {
			window.localStorage.setItem(
				LOCAL_SETTINGS_KEY,
				JSON.stringify({
					...prev,
					...result,
				})
			);
		}
	} catch (err) {}
};

export const getLocalSettings = () => {
	return JSON.parse(window.localStorage.getItem(LOCAL_SETTINGS_KEY)) || {};
};
